export default __webpack_public_path__ + "images/6691d844b437ce2d6dd268c3f00421f6-experiencing_grief_and_loss_during_transitions.svg";